import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Text } from '../../components';
import { authActions } from '../../webapi';
import { useDispatch } from 'react-redux';
import { setAuthUser } from '../../actions';

const LoginComponent = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState(new URLSearchParams(window.location.search));

  useEffect(() => {
    const fetchUser = async () => {
      const res = await authActions.checkUserAuth();
      const userRes = await authActions.getUserSignin();
      if (res.data.type != null) {
        dispatch(setAuthUser(res.data.type, { ...userRes.data, uid: userRes.data.Id }, res.data.site));
      } else {
        dispatch(setAuthUser(null, null));
      }
    };

    if (isAuthenticated && !isLoading) {
      setIsLoadingUser(true);
      fetchUser();
    } else {
      setIsLoadingUser(false);
    }
  }, [isAuthenticated, isLoading, dispatch]);

  let content;
  const error = queryParams.get('error');
  const errorDescription = queryParams.get('error_description');

  if (isLoading) {
    content = <Text type="h2">Checking Login Status...</Text>;
  } else if (isLoadingUser) {
    content = <Text type="h2">Logging in...</Text>;
  } else {
    content = (
      <Button buttonType="primary" onClick={() => loginWithRedirect()} isActive className="button--signup">
        Login
      </Button>
    );
  }

  return (
    <div style={{ width: 450 }}>
      <div className={'marginTop-55 merri-bold fontSize-26 text-plussBlue'}>Sign In</div>
      <div className={'marginTop-16 fontRegular fontSize-16'}>
        Sign in to manage your Pluss Communities, events, users, maintenance requests and more.
      </div>
      <div className="marginTop-40">{content}</div>
      {error && (
        <div className="marginTop-40">
          <p className="text-h3 text-red">There was an issue logging in:</p>
          <p className="text-bodyLarge text-red">{error}</p>
          {!_.isEmpty(errorDescription) && <p className="text-body text-red">{errorDescription}</p>}
        </div>
      )}
    </div>
  );
};

export default LoginComponent;
